import React from "react";
import * as S from "./AlertModal.styles";
import Modal from "..";
import { Button } from "../../../atoms/Buttons";

interface AlertModalType {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  description: React.ReactNode;
  onSubmit?: () => void;
}

const AlertModal = ({
  setIsModal,
  title = "알림",
  description = <>사용 중인 계정에서 로그아웃 하시겠습니까?</>,
  onSubmit,
}: AlertModalType) => {
  return (
    <Modal title={title} titlePosition="center" size="md">
      <S.AlertModalLayout>
        <S.Description>{description}</S.Description>
        <S.ButtonBox>
          {onSubmit ? (
            <>
              <div className="small">
                <Button
                  type="button"
                  size="full"
                  color="transparent"
                  label="취소"
                  onClick={() => setIsModal(false)}
                />
              </div>
              <Button
                type="button"
                size="full"
                color="primary"
                label="확인"
                onClick={() => {
                  onSubmit();
                }}
              />
            </>
          ) : (
            <Button
              type="button"
              size="full"
              color="primary"
              label="확인"
              onClick={() => setIsModal(false)}
            />
          )}
        </S.ButtonBox>
      </S.AlertModalLayout>
    </Modal>
  );
};

export default AlertModal;
